var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Road-st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Road-st0",
    d: "M25.8,19.9c-1.6-1.4-2-1.6-3-2.9c-0.4-0.3,0.7,0,0.5-0.6c-0.4-0.3-1.2-1-1.6-1.4c-0.2-0.6,0.9-0.2,0.7-0.9 c-0.2-0.6-1.9-1.8-2.2-2.3c-1.1-1.2,1,0.4,2.3,1.4c-0.2-0.5,0.8,0.7,1,0.5c0.3-0.4,0.7-0.8-0.7-2.4c-0.3-0.4,0.3-0.4,0.5-0.6 c-2.5-2.1-5.1-4.2-7.9-6.2c-0.7-0.5-1.4-1-2.1-1.4c-0.7-0.5-1.4-0.9-2.3-1.5c-0.2-0.1-0.5-0.3-0.7-0.4C10,1.3,9.9,1.2,9.7,1.1 C9.6,1,9.5,0.9,9.4,1C9.3,1,9.2,0.9,9.1,0.9C8.4,0.6,7.7,0.5,7.1,0.4C5.7,0.3-0.4,7.3,0,8.3c0.5,1.1,0,1.3,0.7,2.2 c0.6,0.8,5.2,4.2,5.8,4.8c0,0.1,0,0.1,0,0.2c2.3,2.5,7,6,9.7,8.1c0.2,0,0.3-0.2,0.5-0.4c-0.3-0.3-0.7-0.4-0.7-0.8 c-0.1-0.1,0.4-0.3,0.5-0.5c-0.1-0.1-2.6-2.2-2.7-2.3c0.2-0.3,1.2,0,1.4-0.3c0.2-0.3-0.3-0.4-0.2-0.7c0-0.4,1.6,0.8,1.8,1 c0.1-0.2,0.1,0.1,0.3-0.1c0.2-0.2,0.4-0.4,0.5-0.7c1.2,0.9,2,1.6,3.2,2.5c0.3,0.1,0.4-0.2,0.5-0.4c-0.5-0.4-2.2-1.7-2.4-2.2 c-0.1-0.1,0.4-0.3,0.5-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.4,0.6-0.5,0.7-0.8c0.1-0.4-0.5-0.6-0.4-0.9c-0.2-0.5,0.5-0.1,0.8,0.2 c0.1-0.3,0.2,0.2,0.4,0c0,0,0.1-0.1,0.1-0.1c1.8,1.5,2.3,1.9,4.1,3.4C25.9,20.7,25.7,20.1,25.8,19.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/Road.bfcd7fcb55672dfa609be326eab75164.svg";
export { ForwardRef as ReactComponent };